module.exports = __webpack_public_path__ + "img/20200512_161739.e4ab7838.jpg";